<template>
  <div>
    <Header></Header>
    <b-container fluid class="home-parent mx-auto">
      <b-row class="my-5 col-lg-7 col-md-10 col-sm-12 mx-auto align-items-center justify-content-center">
        <b-col sm class="my-2">
          <h2 class="text-left">Hello!</h2>
          <p>My name is Akari. I am a product designer with a background in system design engineering, soon graduating from TU Delft.</p>
          <!-- <p>I believe that 'design' is a bridge between 'humans' and 'technology'. As a designer, my focus is not to create new technologies, but to learn about and use these technologies throughout the design process and the product.</p> -->
        </b-col>
        <b-col sm class="my-2">
          <img src="../assets/homeImg.png" class="rounded-img" alt="profile" />
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid>
      <designComp sectionTitle="Portfolio Highlights" projType="Y"></designComp>
    </b-container>
  </div>
</template>

<script>
const designComp = () => import('../components/comp/designComp.vue')
const Header = () => import('../components/Header.vue')

export default {
  name: 'Home', //this is the name of the component
  title: 'Home',
  components: {
    'designComp': designComp,
    'Header': Header,
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .home-parent {
    margin: 150px 0px 100px 0px;
  }
</style>
